import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getAdditionalWorksByProject } from '../services/getAdditionalWorksByProject';

export const loadAdditionalWorks = createAsyncThunk(
  'expenseTracking/loadAdditionalWorks',
  async (params, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    const response = await getAdditionalWorksByProject(selectedProjectId);

    if (Array.isArray(response)) {
      return response;
    }

    if (Array.isArray(response?.additionalWorks)) {
      return response.additionalWorks;
    }

    if (Array.isArray(response?.Items)) {
      return response.Items;
    }

    return [];
  }
);
